import { useCallback } from "react";
import { OnChangeFn, SortingState } from "@/components/Datatable/types";
import { useBillingClientPagination } from "./useBillingClientPagination";
import {
  BillingSortAccessors,
  useBillingClientSorting,
} from "./useBillingClientSorting";

export function useBillingClientTable<T>(
  rows: T[],
  sortAccessors: BillingSortAccessors<T>,
) {
  const { sorting, setSorting, sortedRows } = useBillingClientSorting(
    rows,
    sortAccessors,
  );

  const { pageIndex, pageSize, pageRows, handlePageChange, resetToFirstPage } =
    useBillingClientPagination(sortedRows);

  const handleSortingChange = useCallback<OnChangeFn<SortingState>>(
    (updaterOrValue) => {
      setSorting(updaterOrValue);
      resetToFirstPage();
    },
    [setSorting, resetToFirstPage],
  );

  return {
    sorting,
    handleSortingChange,
    pageIndex,
    pageSize,
    pageRows,
    handlePageChange,
    resetToFirstPage,
  };
}
